// extracted by mini-css-extract-plugin
module.exports = {"root":"expanding-glow_root__3KQxY","rectangle":"expanding-glow_rectangle___CIhI"};